import React from "react";
import { removeSepMoney, sepMony } from "../../../../../../../Common/Function";

const EditComponent = ({ form, setForm, inputs, time, day, show = false }) => {
  const isValid = type => {
    let result = false;
    if (type == "default") {
      result = true;
    } else {
      if (form.option && form.option[type]) {
        result = true;
      }
    }
    return result;
  };
  const editTime = (value, key) => {
    let newTime = form.times[day].map(ch => {
      if (ch._id === time._id) {
        return { ...ch, [key]: value };
      } else {
        return ch;
      }
    });

    setForm({
      ...form,
      times: { ...form.times, [day]: newTime },
    });
  };
  const renderInputs = ({ input, label, key, type }) => {
    switch (input) {
      case "number":
        if (isValid(type)) {
          return (
            <div className="col">
              <label
                className="text-left"
                style={{ flex: 1, width: "100%", textAlign: "left" }}
              >
                {label}
              </label>
              <input
                key={key}
                type="text"
                onChange={({ target: { value } }) => {
                  editTime(removeSepMoney(value), key);
                }}
                step={key === "price" ? 10000 : 20}
                className="form-control"
                defaultValue={sepMony(time[key])}
                readOnly={show}
              />
            </div>
          );
        }
        break;
      case "select":
        if (isValid(type)) {
          return (
            <div className="col" key={key}>
              <label
                className="text-left"
                style={{ flex: 1, width: "100%", textAlign: "left" }}
              >
                {label}
              </label>
              <select
                className="form-control"
                value={time[key]}
                onChange={({ target: { value } }) => {
                  editTime(value, key);
                }}
                readOnly={show}
              >
                {[
                  {
                    label: "آقایان",
                    key: "man",
                  },
                  {
                    label: "بانوان",
                    key: "woman",
                  },
                ].map(op => {
                  return (
                    <option value={op.key} key={op.key}>
                      {op.label}
                    </option>
                  );
                })}
              </select>
            </div>
          );
        }
        break;

      case "text":
        if (isValid(type)) {
          return (
            <div key={key} className="col">
              <label
                className="text-left"
                style={{ flex: 1, width: "100%", textAlign: "left" }}
              >
                {label}
              </label>
              <input
                readOnly={show}
                type="text"
                onChange={({ target: { value } }) => {
                  editTime(value, key);
                }}
                className="form-control"
                defaultValue={time[key]}
              />
            </div>
          );
        }
        break;

      default:
        break;
    }
  };
  return (
    <div>
      {inputs &&
        inputs.map(input => {
          return renderInputs(input);
        })}
    </div>
  );
};

export default EditComponent;
